// extracted by mini-css-extract-plugin
export default {"title":"BracketStage_title--U1n","bracket":"BracketStage_bracket--uUb"};